import { selectedAccommodationId } from '@/layouts/queries'
import apis from '@/services'
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'

const getPlusPerformanceData = async ({ accommodationId, startDate, endDate }) => {
  const response = await apis.premium.getPlusPerformance({
    accommodationId,
    startDate,
    endDate,
  })

  return response?.data
}

export function usePlusInsightsData(startDate, endDate) {
  const isQueryEnabled = computed(() => !!selectedAccommodationId?.value && !!startDate?.value && !!endDate?.value)

  const { data, isFetching, isSuccess, isError, isLoading } = useQuery({
    queryKey: ['StudioPlusInsightsData', selectedAccommodationId, startDate, endDate],
    enabled: isQueryEnabled,
    queryFn: ({ queryKey }) =>
      getPlusPerformanceData({
        accommodationId: queryKey[1],
        startDate: queryKey[2],
        endDate: queryKey[3],
      }),
  })

  const insightsData = computed(() => data?.value)
  const notEnoughData = computed(() => {
    if (!data.value) return false
    const { badgeClicks, badgeViews, websiteClicks } = data.value
    if ([badgeClicks, badgeViews, websiteClicks].some(v => v == null)) return false
    return badgeViews < 400 && badgeClicks < 2 && websiteClicks < 1
  })
  const hasEmptyData = computed(() => {
    if (!data.value) return true
    const { badgeClicks, badgeViews, websiteClicks } = data.value
    return badgeClicks === null && badgeViews === null && websiteClicks === null
  })

  return {
    isFetching,
    isSuccess,
    isError,
    isLoading,
    insightsData,
    hasEmptyData,
    notEnoughData,
  }
}
